document.addEventListener('DOMContentLoaded', function () {
  initSlideInLeft();
  initSlideInRight();

  scrollToSectionKkHomePage();
  menuDropDownCustom();
  testHashUrlNavigation();
  prepareNeighboursShowCarousel();
});

function initSlideInLeft() {
  gsap.to('.kk-animate-slide-in-left', {
    scrollTrigger: {
      trigger: '#kk-what-is-kk',
      start: 'top bottom',
      end: 'top top',
      scrub: true
    },
    width: `70%`,
    ease: 'none'
  });
}

function initSlideInRight() {
  gsap.to('.kk-animate-slide-in-right', {
    scrollTrigger: {
      trigger: '#kk-what-is-kk',
      start: 'top bottom',
      end: 'top top',
      scrub: true
    },
    width: `70%`,
    ease: 'none'
  });
}

function scrollToSectionKkHomePage() {
  if (window.location.hash) {
    //console.log(window.location.hash);
    const targetSection = document.querySelector(window.location.hash);
    if (targetSection) {
      const offset = 150;
      const topPosition = targetSection.getBoundingClientRect().top;
      setTimeout(function () {
        //console.log(topPosition);
        //console.log(window.scrollY);
        //console.log(offset);
        window.scrollTo({
          top: topPosition + window.scrollY - offset,
          behavior: 'smooth'
        });
      }, 200);
    }
  }
}

function scrollHashObserver() {
  const sections = document.querySelectorAll('section');

  const intersectionObserverOptions = {
    threshold: [0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0]
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const location = window.location.toString().split('#')[0];
        const oldHash = window.location.hash;
        const sectionId = entry.target.id;
        const hash = '#' + sectionId;
        if (hash != oldHash) {
          history.replaceState(null, null, location + hash);
        }
      }
    });
  }, intersectionObserverOptions);

  sections.forEach((section) => {
    observer.observe(section);
  });
}

function menuDropDownCustom() {
  jQuery('.dropdown').hover(
    function () {
      jQuery(this).find('.dropdown-menu').stop(true, true).delay(100).fadeIn(200);
    },
    function () {
      jQuery(this).find('.dropdown-menu').stop(true, true).delay(100).fadeOut(200);
    }
  );


}

function testHashUrlNavigation() {
  jQuery('.menu-item-type-custom .nav-link, .dropdown-menu .dropdown-item').bind('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    const hrefUrl = e.target.href;
    const splitHashUrls = hrefUrl.split('#');
    const hashUrl = splitHashUrls[1];
    if (hashUrl) {
      const targetSection = document.getElementById(hashUrl);
      if (targetSection) {
        const offset = 150;
        const topPosition = targetSection.getBoundingClientRect().top;
        setTimeout(function () {
          //console.log(topPosition);
          //console.log(window.scrollY);
          //console.log(offset);
          window.scrollTo({
            top: topPosition + window.scrollY - offset,
            behavior: 'smooth'
          });
        }, 200);
      } else {
        window.location.href = hrefUrl;
      }
    } else {
      window.location.href = hrefUrl;
    }
  });
}

function prepareNeighboursShowCarousel() {
  const myCarousel = document.getElementById('kk-campaign-carousel-main');
  if (myCarousel) {
    const carousel = new bootstrap.Carousel(myCarousel, {
      interval: 1000,
      touch: true,
      wrap: false,
      ride: false
    });

    myCarousel.addEventListener('slide.bs.carousel', (event) => {
      //console.log(event, ' - start');
      const sideDummyImages = 'single-kkcampaigns';
      const sideDummyImageElement = document.querySelector(`.${sideDummyImages}`);
      //if (event.direction === 'right') {
        sideDummyImageElement.style.setProperty('--dummyimageleftvisibility', `hidden`);
      //}
      //if (event.direction === 'left') {
        sideDummyImageElement.style.setProperty('--dummyimagerightvisibility', `hidden`);
      //}
      const targetElement = event.relatedTarget;
      targetElement.classList.toggle('opacity-show');
      //debugger;
    });

    myCarousel.addEventListener('slid.bs.carousel', (event) => {
      //console.log(event, ' - end');
      const sideDummyImages = 'single-kkcampaigns';
      const sideDummyImageElement = document.querySelector(`.${sideDummyImages}`);
      //if (event.direction === 'right') {
        sideDummyImageElement.style.setProperty('--dummyimageleftvisibility', `visible`);
      //}
      //if (event.direction === 'left') {
        sideDummyImageElement.style.setProperty('--dummyimagerightvisibility', `visible`);
      //}
      const targetElement = event.relatedTarget;
      targetElement.classList.toggle('opacity-show');
      //debugger;
    });
  }
}
